export enum RegistrationStatus{
    NOT_REGISTERED = 'NOT_REGISTERED',
    PRE_REGISTERED = 'PRE_REGISTERED',
    REGISTERED = 'REGISTERED'
}